/**
 * Shared currency list and formatter for Pricing and Billing pages.
 * Rates are approximate; billing is always in USD.
 */

import usFlag from '../assets/icons/flags/us.png';
import euFlag from '../assets/icons/flags/eu.png';
import gbFlag from '../assets/icons/flags/gb.png';

export const CURRENCIES = [
  { code: 'USD', label: 'US Dollar', symbol: '$', flagImg: usFlag, rate: 1 },
  { code: 'EUR', label: 'Euro', symbol: '€', flagImg: euFlag, rate: 0.92 },
  { code: 'GBP', label: 'British Pound', symbol: '£', flagImg: gbFlag, rate: 0.79 },
];

/**
 * Renders an approximate list price in the selected display currency.
 * Converted amounts are rounded to the nearest whole unit (no cent/penny decimals).
 */
export function formatPrice(usdAmount, currency) {
  const n = Number(usdAmount);
  if (!Number.isFinite(n) || n === 0) return currency.symbol + '0';
  const value = Math.round(n * currency.rate);
  if (value === 0) return currency.symbol + '0';
  return currency.symbol + value.toLocaleString();
}
